<template lang="pug">
.v-header-buttons.header-buttons(v-if="items")
	.header-buttons__item(v-for="item in items")
		v-dropdown(:title="item.title" :link="item.link" :direction="item.direction")
			template(#btn)
				component(v-if="item.button" :is="item.button.link ? 'a' : 'button'" :href="item.button.link" :type="item.button.link ?  null : 'button'" :class="[item.button.className ? 'btn ' + item.button.className : 'top-link__item-btn', item.button.active ? 'active' : '']")
					v-svg-icon.btn__icon(v-if="item.button.icon" :icon="item.button.icon")
					span(:class="[item.button.className ? '' : 'top-link__item-text']") {{ item.isSelected ? locale : item.button.text}}
					v-svg-icon(:class="[item.button.className ? 'btn__arrow' : 'top-link__item-icon']" icon="select-arrow")
			template(#content)
				v-navigation-links(v-if="item.items" :items="item.items" :without-icon="item.withoutIcon || false" :is-selected="item.isSelected" @model-value="(e) => locale = e.text")
</template>

<script>

export default {
	props: {
		items: {
			type: Array,
			default: null
		}
	},

	data() {
		return {
			locale: 'Ru'
		}
	}
}
</script>